define.alias("shared/components/shared/creator-profile-modal", "settings/components/shared/creator-profile-modal");